import { render, staticRenderFns } from "./ProblemHandling.vue?vue&type=template&id=00e67c56&scoped=true"
import script from "./ProblemHandling.vue?vue&type=script&lang=js"
export * from "./ProblemHandling.vue?vue&type=script&lang=js"
import style0 from "./ProblemHandling.vue?vue&type=style&index=0&id=00e67c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e67c56",
  null
  
)

export default component.exports